import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast, isNative } from '../context/MenuProvider'


function Logout({ setToken, storage }) {
  const navigate = useNavigate();
  const {
    excluirDadosCompleto,
    setTokenAdmin,
    salvarDados,
    buscarDados,
  } = useProvider();
  const { tipo } = useParams();

  useEffect(() => {
    const logout = async () => {
      try {
        if (tipo === "all"){
          if (isNative) window.dispatchNativeMessage('logout_all');
          if(!isNative) navigator.serviceWorker.controller.postMessage('logout_all');
          Swal.fire({
            icon: 'success',
            title: 'Obrigado :)',
            text: 'Todos dispositivos foram desconectados... Estarei aqui aguardando seu retorno, até mais...',
          });
        } else {
          if (isNative) window.dispatchNativeMessage('logout');
          if(!isNative) navigator.serviceWorker.controller.postMessage('logout');
          Swal.fire({
            icon: 'success',
            title: 'Obrigado :)',
            text: 'Estarei aqui aguardando seu retorno, até mais...',
          });
        }
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Erro ao realizar logout:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível realizar o logout.',
        });
      }
    };
    logout();
  }, []); // Inclua dependências no array de dependências
  return (<></>); // Retorne null ou algum JSX se necessário
}

export default Logout;